<template>
  <div class="items-list-sortable">
    <slot></slot>
  </div>
</template>

<script>
import Sortable from 'sortablejs'
export default {
  name: 'ItemsListSort',
  props: {
    querySelector: {
      type: String,
      default: '.el-table__body-wrapper tbody'
    },
    passedOptions: {
      type: Object,
      default: () => ({})
    }
  },
  data () {
    return {
      // 排序實例
      instance: null,
      // 排序設定值
      options: {
        animation: 150,
        disabled: false,
        ghostClass: 'ghost',
        handle: '.drag-handle',
        onEnd: evt => this.handleDragEnd(evt)
      }
    }
  },
  created () {
    this.options = Object.assign(this.options, this.passedOptions) // 合併傳入參數
  },
  methods: {
    // 初始化排序實例
    init () {
      this.instance = new Sortable(this.$el.querySelector(this.querySelector), this.options)
    },
    // 銷毀排序實例
    destroy () {
      if (this.instance) { this.instance.destroy() }
    },
    // 處理拖曳結束
    handleDragEnd ({ oldIndex, newIndex }) {
      this.$emit('drag-end', { oldIndex, newIndex })
    }
  }
}
</script>

<style lang="scss" scoped>
.items-list-sortable {
  width: 100%;
}
</style>
